import React, { useRef, useState } from "react";
import "./style.scss";
import { useQuery } from "react-query";
import { goAxiosInstance } from "helpers/axiosInstance";
import ListingExperienceCard from "./ListinExperienceCard";
import SaffSlider from "components/SaffSlider";
import clevertap from "clevertap-web-sdk";
import { ListingHeadingReuseComp } from "components/ListingNew/ListingHeadingReuseComp";
import useCheckEndsReached from "customHooks/useCheckEndsReached";
import { SvgButtonArrowLeft } from "assets/icons/js/SvgButtonArrowLeft";
import { SvgButtonArrowRight } from "assets/icons/js/SvgButtonArrowRight";
import { useTheme } from "components/ListingNew/ListingTheme";
export interface SingleAddon {
	ADD_ON_ID: number;
	ADD_ON_NAME: string;
	PRICE: number;
	GST_SLAB: number;
	TYPE: string;
	DESCRIPTION: string;
	POINTERS: string;
	IMAGE_URL: string;
	PAYMENT_TYPE: string;
	CREATED_ON: string;
	CREATED_BY: string;
	MODIFIED_ON?: string;
	MODIFIED_BY?: string;
	LISTING_ID: string;
	MAP_ID: number;
	ADD_ON_STATUS: number;
	IS_VISIBLE: number;
	CATEGORY: string;
}
const ListingExperience = ({ listingData }: { listingData: any }) => {
	const listingId = listingData?.data?.listing_list?.id;
	const [addOnData, setAddOnData] = useState([]);
	const { data }: any = useQuery(
		["listingExperience", listingId],
		() => {
			return goAxiosInstance({
				url: `/get-listing-addons?listingId=${listingId}`,
				method: "GET",
			});
		},
		{
			onSuccess: (data) => {
				if (data?.data?.data) {
					setAddOnData(data?.data?.data);
				}
			},
		},
	);

	//check reaching ends of the list
	const listRef = useRef<HTMLDivElement>(null);
	const { reachedRight, reachedLeft } = useCheckEndsReached({ ref: listRef });

	const handleScrollLeft = () => {
		if (listRef.current) {
			listRef.current.scrollLeft -= 595;
		}
	};

	const handleScrollRight = () => {
		if (listRef.current) {
			listRef.current.scrollLeft += 590;
		}
	};

	const handleContentClick = () => {
		clevertap.event.push("listing-experience-overlall", {
			LISTING_ID: listingId,
		});
	};

	const theme = useTheme();

	if (addOnData.length === 0) {
		return null;
	}
	return (
		<ListingHeadingReuseComp
			heading="Experiences"
			comp={
				<div className="listing-experience-wrapper">
					<h2>
						<div className="listing__spotlight-arrows">
							<span className="button-one" onClick={handleScrollLeft}>
								{reachedLeft ? (
									<SvgButtonArrowLeft
										rectFill={theme?.background}
										rectStroke={theme?.textButtonColor}
										pathFill={theme?.textButtonColor}
									/>
								) : (
									<SvgButtonArrowRight
										rectFill={theme?.background}
										rectStroke={theme?.textButtonColor}
										pathFill={theme?.textButtonColor}
										style={{ transform: "rotate(180deg)" }}
									/>
								)}
							</span>
							<span className="button-two" onClick={handleScrollRight}>
								{reachedRight ? (
									<SvgButtonArrowLeft
										rectFill={theme?.background}
										rectStroke={theme?.textButtonColor}
										pathFill={theme?.textButtonColor}
										style={{ transform: "rotate(180deg)" }}
									/>
								) : (
									<SvgButtonArrowRight
										rectFill={theme?.background}
										rectStroke={theme?.textButtonColor}
										pathFill={theme?.textButtonColor}
									/>
								)}
							</span>
						</div>
						{/* )} */}
					</h2>
					<div
						className="listing-experience-content"
						onClick={handleContentClick}
						ref={listRef}
					>
						{addOnData.map((ele: SingleAddon, index: number) => {
							return (
								<ListingExperienceCard
									allAddons={addOnData}
									singleAddon={ele}
									index={index}
									listingId={listingId}
								/>
							);
						})}
					</div>
				</div>
			}
		></ListingHeadingReuseComp>
	);
};

export default ListingExperience;
